<div class="root-body"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">

    <div class="root-body-inner pmlg-root-block">
        <!-- Empty page -->
        <div *ngIf="!groups.length && groupsLoaded" class="pmlg-empty-block">
            <div class="filler"></div>

            <div class="pmlg-center-block pmlg-empty-title">Location Groups</div>

            <div class="pmlg-center-block pmlg-empty-text-block">
                <div>
                    Use Location groups to group similar locations together. Grouped locations can benefit from different rules that are applied to other locations.
                </div>
                <div style="margin-top: 10px;">
                    For example:
                </div>
                <div style="margin-top: 10px; font-weight: 500;">
                    Group Inventory
                </div>
                <div>
                    Inventory for groups can have different Selling Prices, Daily Inventory Levels & Suppliers
                </div>
                <div style="margin-top: 10px; font-weight: 500;">
                    Store Hours
                </div>
                <div>
                    Apply different store hours for stores within the group
                </div>
            </div>

            <div class="pmlg-center-block" style="margin-top: 30px;">
                <button pButton type="button" icon="pi pi-plus" label="Create Group"
                        (click)="onCreateGroupClick()"></button>
            </div>

            <div class="filler"></div>
        </div>

        <!-- Table -->
        <p-table [columns]="cols"
                 [value]="groups"
                 [lazy]="true"
                 (onLazyLoad)="handleLazyLoad($event)"
                 [paginator]="true"
                 [(first)]="first"
                 [rows]="rowsPerPage"
                 [rowsPerPageOptions]="rowsPerPageOptions"
                 [totalRecords]="totalRecords"
                 [resizableColumns]="true"
                 [columnResizeMode]="'expand'"
                 [autoLayout]="true"
                 [style.display]="groups.length && groupsLoaded ? '' : 'none'"
                 [styleClass]="'p-datatable-striped'"
                 [scrollable]="true"
                 [scrollHeight]="'flex'">
            <ng-template pTemplate="caption">
                <div class="flex-row">
                    <div class="filler"></div>

                    <div>
                        <button pButton type="button" icon="pi pi-plus" label="Create Group"
                                style="margin-left: 10px; margin-right: 10px;"
                                (click)="onCreateGroupClick()"></button>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let col of cols"
                        [pSortableColumn]="col.field"
                        [pSortableColumnDisabled]="col.disableSort"
                        pResizableColumn
                        [style.width]="col.width">
                        {{col.header}}
                        <p-sortIcon *ngIf="sortField===col.field" [field]="col.field"></p-sortIcon>
                    </th>
                    <th>Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-group>
                <tr>
                    <td *ngFor="let col of cols"
                        class="ui-resizable-column"
                        [style.width]="col.width">
                        {{group[col.field]}}
                    </td>
                    <td>
                        <span class="action-icon-svg" (click)="onSelectGroupClick(group)">
                            <img src="{{adminUrl}}XpressApp/assets/images/grid/icon_view.svg" />
                        </span>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="paginatorleft" let-state>
                <div *ngIf="groups.length > 0" style="padding-left: 10px">
                    Displaying {{first + 1}} - {{first + groups.length}} of {{totalRecords}}
                </div>
            </ng-template>
        </p-table>
    </div>
</div>

<partner-mart-locations-create-group *ngIf="isCreateGroupPopupVisible"
                                     [merchantId]="merchantId"
                                     [onSave]="onCreateGroupPopupSave"
                                     [onHide]="onCreateGroupPopupHide"></partner-mart-locations-create-group>

<spinner *ngIf="isSpinnerVisible" style="position: fixed; top: 40vh; left: 60vw"></spinner>

<p-toast position="top-right"></p-toast>
